import {
  DhlList as NewList,
  DhlListItem as NewListItem,
} from "@dhl-official/react-library";
import React from "react";
import PropTypes from "prop-types";

/**
 * Migration wrapper for List component
 * This component helps transition from old UI library to new UI library
 * by handling prop mapping and maintaining backward compatibility
 */
export const List = (props) => {
  const { variant, children, ...rest } = props;

  const newProps = {
    ...rest,
    type: variant,
  };

  return <NewList {...newProps}>{children}</NewList>;
};

List.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.node,
};

// Preserve static properties from the old List component
List.CHECK = "check";
List.ITEM = "item";
List.ORDERED = "ordered";
List.UNORDERED = "unordered";

// Create a wrapper for List.Item to maintain the same API
List.Item = (props) => {
  const { children, ...rest } = props;
  return <NewListItem {...rest}>{children}</NewListItem>;
};

List.Item.propTypes = {
  children: PropTypes.node,
};
